// FileName: /Home.tsx
import React, { useEffect, useState, useRef, useMemo, useCallback } from 'react'
import { PageLink, PageTitle } from '../../_metronic/layout/core'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Popover from 'react-bootstrap/Popover'
import { useMutation, useQueryClient } from 'react-query'
import { KTCard, KTSVG } from '../../_metronic/helpers'
import { KTCardBody } from '../../_metronic/helpers'
import { useNavigate } from 'react-router-dom'
import { Maintable } from '../tables/Maintable'
import { UpdatePurchase } from './modals/UpdatePurchase'
import { AddPurchase } from './modals/AddPurchase'
import { AddSupplier } from '../suppliers/modals/AddSupplier'
import { DeletePurchase } from './modals/DeletePurchase'
import { DeletePurchaseItem } from './modals/DeletePurchaseItem'
import { ItemsSummary } from '../topdashboard/ItemsSummary'
import { getPurchases } from '../apis/Loadalltabledata'
import {
  usePurchases,
  useDeletePurchase,
  useVariance,
  useSumPurchases,
  useAllPurchases,
} from '../contextProviders/Atomqueryprovider'
import CountUp from 'react-countup'
import LoadingBar from 'react-top-loading-bar'
import { Column } from 'react-table'
import { useAuth } from '../../app/modules/auth'
import { useWindowWidth } from '@react-hook/window-size/throttled'
import dayjs from 'dayjs'
import * as XLSX from 'xlsx'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import relativeTime from 'dayjs/plugin/relativeTime'
import calendar from 'dayjs/plugin/calendar'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import isBetween from 'dayjs/plugin/isBetween'
import io from 'socket.io-client'
import truncate from 'truncate'
import { useDashboard } from '../contextProviders/Dashboardcontext'
import '../css/popover.css'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(relativeTime)
dayjs.extend(calendar)
dayjs.extend(localizedFormat)
dayjs.extend(isBetween)

const API_URL = process.env.REACT_APP_API_URL
const CURRENCY_APP = process.env.REACT_APP_CURRENCY
const OPENING_TIME = process.env.REACT_APP_OPENING_TIME
const socket = io('possocket.27mirrors.com')

const isNegative = (num: number) => Math.sign(num) === -1
const addCommas = (num: number) => num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')

// Status badge utility functions
const getPaymentStatusBadge = (paymentStatus: string) => {
  const status = paymentStatus?.toLowerCase() || '';

  switch (status) {
    case 'paid':
      return 'badge-light-success';
    case 'partial':
      return 'badge-light-warning';
    case 'unpaid':
    case 'pending':
      return 'badge-light-danger';
    case 'overdue':
      return 'badge-dark';
    default:
      return 'badge-light';
  }
};

const getOrderStatusBadge = (orderStatus: string) => {
  const status = orderStatus?.toLowerCase() || '';

  switch (status) {
    case 'received':
    case 'completed':
    case 'delivered':
      return 'badge-light-success';
    case 'pending':
    case 'ordered':
      return 'badge-light-primary';
    case 'processing':
    case 'in transit':
    case 'shipped':
      return 'badge-light-info';
    case 'cancelled':
    case 'rejected':
      return 'badge-light-danger';
    case 'on hold':
    case 'backordered':
      return 'badge-light-warning';
    default:
      return 'badge-light';
  }
};

const usersBreadcrumbs: Array<PageLink> = [
  {
    title: 'Dashboard',
    path: '/dashboard',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

// --- Updated Interfaces for proper type safety ---

interface ProductDetails {
  product_name: string
  product_description: string
  barcode: string
  unit_buying_price: number
  unit_selling_price: number
  discount_percentage: number
  units_in_stock: number
  reorder_level: number
  product_division: number
  product_image: string
  category_name: string
  category_id: number
  unit_name: string
  unit_id: number
}

interface PurchaseItem {
  purchase_item_id: number
  product_id: number
  quantity: number
  unit_cost: number
  total_cost: number
  received_quantity: number
  product_details: ProductDetails
}

interface SupplierDetails {
  supplier_id: number
  supplier_name: string
  supplier_company_name: string | null
  supplier_phone_number: string
  supplier_email: string
  supplier_payment_details: string
  supplier_address: string | null
}

interface UserDetails {
  user_id: number
  user_first_name: string
  user_second_name: string
}

interface PurchaseData {
  purchase_id: number
  purchase_number: string
  supplier_id: number
  purchase_order_id: number | null
  total_amount: number
  amount_paid: number
  balance_due: number
  payment_status: string
  payment_terms: string
  due_date: string
  purchase_date: string
  received_date: string | null
  user_id: number
  notes: string | null
  status: string
  items: PurchaseItem[]
  supplier_details: SupplierDetails
  user_details: UserDetails
}

interface PurchaseWithValue extends PurchaseData {
  value: number
}

interface CategoryBreakdown {
  [key: string]: {
    count: number
    totalValue: number
    totalStock: number
  }
}

interface PurchaseAnalysis {
  totalPurchases: number
  totalValue: number
  totalPaid: number
  totalDue: number
  lowValueItems: PurchaseData[]
  highValueItems: PurchaseData[]
  supplierBreakdown: CategoryBreakdown
  averageValue: number
  topPurchases: PurchaseWithValue[]
  riskItems: PurchaseData[]
}

interface AllPurchasesResponse {
  data: {
    purchases: PurchaseData[]
    datalength: number
  }
}



const Purchases = () => {
  const queryClient = useQueryClient()
  const refloadingbar = useRef<any>(null)
  const isMounted = useRef(true);
  const myRefsearch = useRef<HTMLInputElement>(null)
  const { currentUser } = useAuth()
  const navigate = useNavigate()

  const [modalshow, setModalshow] = useState(false)
  const [modalpurchaseupdateshow, setModalpurchaseupdateshow] = useState(false)
  const [modalshowdelete, setModalshowdelete] = useState(false)
  const [modalshowdeleteitem, setModalshowdeleteitem] = useState(false)
  const [statedeletingpurchase, setStatedeletingpurchase] = useState(false)
  const [purchasetodelete, setPurchasetodelete] = useState<PurchaseData | {}>({})
  const [purchasetoupdate, setPurchasetoupdate] = useState<PurchaseData | {}>({})
  const [itemtodelete, setItemtodelete] = useState<PurchaseItem | {}>({})
  const [cannotDeletepurchase, setCannotDeletepurchase] = useState(false)
  const [startlimitsumdash, setStartlimitsumdash] = useState<number>(0)
  const [database_limitsumdash, setDatabase_limitsumdash] = useState<number>(7)
  const [statusnow, setStatusnow] = useState<boolean>(false)
  const [statusnow2, setStatusnow2] = useState<boolean>(false)
  const [statusssumdash, setStatussumdash] = useState<string>('%')
  const [paginationsize, setPaginationsize] = useState<number>(10)
  const [startlimit, setStartlimit] = useState<number>(0)
  const [itemto_order, setItemto_order] = useState<string>('purchase_date')
  const [desorasc, setDesorasc] = useState<string>('DESC')
  const [serversort, setServersort] = useState<any>([])
  const [search_item, setSearch_item] = useState<string>('%')
  const [pageCount, setPageCount] = useState<number>(0)
  const [movetofirstpage, setMovetofirstpage] = useState<boolean>(false)
  const [modalSupplierShow, setModalSupplierShow] = useState(false)
  const [sumPurchasesdata, setSumPurchasesdata] = useState<any>([])
  const showSupplierModal = useCallback(() => setModalSupplierShow(true), [])
  const hideSupplierModal = useCallback(() => setModalSupplierShow(false), [])
  const { showDashboard, toggleDashboard } = useDashboard();

  const onlyWidth = useWindowWidth()

  const startDate = useMemo(() => new Date(dayjs().subtract(5, 'years').startOf('year').format('YYYY-MM-DD')), [])
  const endDate = useMemo(() => new Date(dayjs().endOf('year').format('YYYY-MM-DD')), [])

  // Ref for AddPurchase modal
  const addPurchaseRef = useRef<any>(null);
  const [modalAddPurchaseMode, setModalAddPurchaseMode] = useState<'new' | 'add'>('new');
  const [purchaseToAddTo, setPurchaseToAddTo] = useState<PurchaseData | {}>({});

  // Queries
  const {
    isLoading: allpurchasesloading,
    isSuccess: allpurchasessuccess,
    data: allpurchasesdata,
    status: allpurchasesstatus,
    isPreviousData: allpurchasespreviousdata,
    refetch: allpurchasesrefetch,
  } = usePurchases(
    Number(currentUser?.user_id),
    startlimit,
    paginationsize,
    startDate,
    endDate,
    itemto_order,
    desorasc,
    search_item
  )

  const {
    data: sumpurchasedata,
    isSuccess: sumpurchasesuccess,
    isRefetching: sumpurchaserefetching,
    refetch: sumpurchaserefetch,

  } = useSumPurchases(
    Number(currentUser?.user_id),
    statusssumdash,
    new Date(
      dayjs
        .unix(
          dayjs(
            dayjs().startOf('month').subtract(7, 'days').format('YYYY-MM-DD') + OPENING_TIME
          ).unix()
        )
        .format('YYYY-MM-DD hh:mm')
    ),
    new Date(
      dayjs(dayjs().add(1, 'month').startOf('month').format('YYYY-MM-DD') + OPENING_TIME).format(
        'YYYY-MM-DD hh:mm'
      )
    ),
    startlimitsumdash,
    database_limitsumdash
  )

  const {
    data: variancedata,
    isSuccess: variancesuccess,
    isRefetching: variancerefetching,
    refetch: variancerefetch,
  } = useVariance(
    Number(currentUser?.user_id),
    startDate,
    endDate,
    0,
    366
  )

  const {
    data: allPurchasesForReport,
    refetch: allPurchasesForReportRefetch
  } = useAllPurchases(
    Number(currentUser?.user_id),
    0,
    10000,
    startDate,
    endDate,
    'purchase_date',
    'DESC',
    '%'
  ) as { data: AllPurchasesResponse; refetch: () => Promise<any> }

  const { mutateAsync: deletePurchaseMutateAsync } = useDeletePurchase(
    (purchasetodelete as PurchaseData)?.purchase_id || 0,
    Number(currentUser?.user_id)
  )

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);


  useEffect(() => {
    if (!sumpurchaserefetching && sumpurchasesuccess) {
      setSumPurchasesdata(sumpurchasedata?.data)

    }

  }, [sumpurchasesuccess, sumpurchaserefetching])

  // Effects
  useEffect(() => {
    if (!allpurchasespreviousdata && allpurchasessuccess) {
      const totalPages = Math.ceil(allpurchasesdata.data.datalength / paginationsize)
      if (startlimit / paginationsize < totalPages - 1) {
        queryClient.prefetchQuery(
          [
            'allpurchases',
            currentUser?.user_id,
            startlimit + paginationsize,
            paginationsize,
            startDate,
            endDate,
            itemto_order,
            desorasc,
            search_item,
          ],
          () =>
            getPurchases(
              Number(currentUser?.user_id || 0),
              startlimit + paginationsize,
              paginationsize,
              startDate,
              endDate,
              itemto_order,
              desorasc,
              search_item,
            )
        )
      }
    }
  }, [
    allpurchasesdata,
    allpurchasespreviousdata,
    allpurchasessuccess,
    startlimit,
    paginationsize,
    queryClient,
    itemto_order,
    desorasc,
    search_item,
    currentUser,
    startDate,
    endDate,
  ])

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (refloadingbar.current) {
          await refloadingbar.current?.continuousStart()
        }
        await allpurchasesrefetch()
      } catch (error) {
        console.log(error)
      } finally {
        if (isMounted.current && refloadingbar.current) {
          refloadingbar.current.complete()
        }
      }
    }
    fetchData()
  }, [itemto_order, desorasc, search_item, allpurchasesrefetch])

  useEffect(() => {
    if (serversort.length > 0) {
      setItemto_order(serversort.map((x: any) => x.id)[0])
      setDesorasc(serversort.map((x: any) => x.desc)[0] ? 'DESC' : 'ASC')
    } else {
      setItemto_order('purchase_date')
      setDesorasc('DESC')
    }
  }, [serversort])


  useEffect(() => {
    if (sumpurchasesuccess) {
      setStatusnow(true)
    }
  }, [sumpurchasesuccess])

  useEffect(() => {
    if (
      statusnow &&
      !sumpurchaserefetching
    ) {
      setStatusnow2(true)
    }
  }, [sumpurchaserefetching])


  useEffect(() => {
    socket.on('update', async (_arg: any) => {
      try {
        if (refloadingbar.current) {
          await refloadingbar.current?.continuousStart()
        }
        await allpurchasesrefetch()
        await variancerefetch()
        await sumpurchaserefetch()
      } catch (error) {
        console.log(error)
      } finally {
        if (isMounted.current && refloadingbar.current) {
          refloadingbar.current.complete()
        }
      }
    })
    return () => {
      socket.off('update')
    }
  }, [allpurchasesrefetch, variancerefetch, sumpurchaserefetch])

  // Data Memos - Updated to handle new structure
  const tabledata = useMemo(() => {
    if (allpurchasessuccess && allpurchasesdata?.data?.purchases) {
      return allpurchasesdata.data.purchases
    }
    return []
  }, [allpurchasessuccess, allpurchasesdata])

  const tabledatalength = useMemo(
    () => (allpurchasessuccess && allpurchasesdata?.data ? allpurchasesdata.data.datalength : 0),
    [allpurchasessuccess, allpurchasesdata]
  )

  // Summary Data
  const totalPurchases = useMemo(() => sumpurchasedata?.data?.totalPurchases || 0, [sumpurchasedata])
  const totalValue = useMemo(() => sumpurchasedata?.data?.totalValue || 0, [sumpurchasedata])
  const totalDue = useMemo(() => variancedata?.data?.totalDue || 0, [variancedata])
  const totalPaid = useMemo(() => sumpurchasedata?.data?.totalPaid || 0, [sumpurchasedata])

  // Event Handlers
  const showModal = useCallback(() => {
    setModalAddPurchaseMode('new');
    setPurchaseToAddTo({});
    setModalshow(true);
    addPurchaseRef.current?.Resetmodalvalues();
  }, [])
  const hideModal = useCallback(() => setModalshow(false), [])

  const showpurchaseupdateModal = useCallback((purchase: PurchaseData) => {
    setPurchasetoupdate(purchase)
    setModalpurchaseupdateshow(true)
  }, [])

  const hideUpdateModal = useCallback(() => {
    setModalpurchaseupdateshow(false)
    setPurchasetoupdate({})
  }, [])

  const showModaldelete = useCallback((purchase: PurchaseData) => {
    setPurchasetodelete(purchase)
    setModalshowdelete(true)
    setStatedeletingpurchase(false)
    setCannotDeletepurchase(false)
  }, [])

  const hideModaldelete = useCallback(() => {
    setModalshowdelete(false)
    setPurchasetodelete({})
  }, [])

  const deleteselectedpurchase = async () => {
    setStatedeletingpurchase(true)
    setCannotDeletepurchase(false)
    try {
      await deletePurchaseMutateAsync()
      setStatedeletingpurchase(false)
      setModalshowdelete(false)
      allpurchasesrefetch()
      sumpurchaserefetch()
      variancerefetch()
    } catch (error) {
      setStatedeletingpurchase(false)
      setCannotDeletepurchase(true)
    }
  }

  const handleSearch = () => {
    const inputValue = myRefsearch.current?.value
    setSearch_item(inputValue ? `${inputValue}%` : '%')
    setStartlimit(0)
    setMovetofirstpage(true)
  }

  const handleSearchOnEnter = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') handleSearch()
  }

  const handleSearchOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.value) handleSearch()
  }

  const handleAddItemsToPurchase = useCallback((purchase: PurchaseData) => {
    setModalAddPurchaseMode('add');
    setPurchaseToAddTo(purchase);
    setModalshow(true);
    addPurchaseRef.current?.ResetmodalvaluesForAddItems(purchase);
  }, []);

  const showModaldeleteitem = useCallback((item: PurchaseItem) => {
    setItemtodelete(item)
    setModalshowdeleteitem(true)
  }, [])

  const hideModaldeleteitem = useCallback(() => {
    setModalshowdeleteitem(false)
    setItemtodelete({})
  }, [])

  const downloadReport = async () => {
    try {
      if (refloadingbar.current) {
        refloadingbar.current.continuousStart()
      }

      await allPurchasesForReportRefetch()

      const allPurchases = allPurchasesForReport?.data?.purchases
      if (!allPurchases || allPurchases.length === 0) {
        alert('No purchase data available to export')
        return
      }

      const analysis: PurchaseAnalysis = {
        totalPurchases: allPurchases.length,
        totalValue: allPurchases.reduce((sum: number, p: PurchaseData) => sum + (Number(p.total_amount) || 0), 0),
        totalPaid: allPurchases.reduce((sum: number, p: PurchaseData) => sum + (Number(p.amount_paid) || 0), 0),
        totalDue: allPurchases.reduce((sum: number, p: PurchaseData) => sum + (Number(p.balance_due) || 0), 0), // Added this line
        lowValueItems: allPurchases.filter((p: PurchaseData) => (Number(p.total_amount) || 0) <= 10000),
        highValueItems: allPurchases.filter((p: PurchaseData) => (Number(p.total_amount) || 0) > 10000),
        supplierBreakdown: {} as CategoryBreakdown,
        averageValue: 0,
        topPurchases: [],
        riskItems: [],
      }

      allPurchases.forEach((p: PurchaseData) => {
        const supplier = p.supplier_details?.supplier_name || 'Unspecified'
        if (!analysis.supplierBreakdown[supplier]) {
          analysis.supplierBreakdown[supplier] = { count: 0, totalValue: 0, totalStock: 0 }
        }
        analysis.supplierBreakdown[supplier].count++
        analysis.supplierBreakdown[supplier].totalValue += Number(p.total_amount) || 0
        analysis.supplierBreakdown[supplier].totalStock += p.items?.reduce((sum: number, item: PurchaseItem) => sum + item.quantity, 0) || 0
      })

      analysis.averageValue = analysis.totalPurchases
        ? analysis.totalValue / analysis.totalPurchases
        : 0

      analysis.topPurchases = allPurchases
        .map((p: PurchaseData) => ({ ...p, value: Number(p.total_amount) || 0 }))
        .sort((a: PurchaseWithValue, b: PurchaseWithValue) => b.value - a.value)
        .slice(0, 10)

      const wb = XLSX.utils.book_new()
      const purchasesSheet = XLSX.utils.json_to_sheet(
        allPurchases.map((p: PurchaseData) => ({
          ID: p.purchase_id,
          Number: p.purchase_number,
          Supplier: p.supplier_details?.supplier_name || 'N/A',
          Total: p.total_amount,
          Paid: p.amount_paid,
          Balance: p.balance_due,
          Status: p.payment_status,
          Date: p.purchase_date,
          Due: p.due_date,
        }))
      )
      XLSX.utils.book_append_sheet(wb, purchasesSheet, 'Purchases')

      const summarySheet = XLSX.utils.json_to_sheet([
        { Metric: 'Total Purchases', Value: analysis.totalPurchases },
        { Metric: 'Total Value', Value: analysis.totalValue },
        { Metric: 'Total Paid', Value: analysis.totalPaid },
        { Metric: 'Total Due', Value: analysis.totalDue }, // Added this line
        { Metric: 'Average Value', Value: analysis.averageValue },
      ])
      XLSX.utils.book_append_sheet(wb, summarySheet, 'Summary')

      const supplierSheet = XLSX.utils.json_to_sheet(
        Object.entries(analysis.supplierBreakdown).map(([supplier, data]) => ({
          Supplier: supplier,
          Count: data.count,
          TotalValue: data.totalValue,
        }))
      )
      XLSX.utils.book_append_sheet(wb, supplierSheet, 'Suppliers')

      const topPurchasesSheet = XLSX.utils.json_to_sheet(
        analysis.topPurchases.map((p: PurchaseWithValue) => ({
          ID: p.purchase_id,
          Number: p.purchase_number,
          Supplier: p.supplier_details?.supplier_name || 'N/A',
          Value: p.value,
        }))
      )
      XLSX.utils.book_append_sheet(wb, topPurchasesSheet, 'Top Purchases')

      XLSX.writeFile(wb, `purchase_report_${new Date().toISOString().split('T')[0]}.xlsx`)
    } catch (error) {
      console.error('Error generating purchase report:', error)
      alert('Error generating report. Please try again.')
    } finally {
      if (isMounted.current && refloadingbar.current) {
        refloadingbar.current.complete()
      }
    }
  }
  // --- Updated Table Column Definitions with Improved Status Badges ---

  const baseColumns: ReadonlyArray<Column<PurchaseData>> = useMemo(() => [
    {
      Header: 'P.No',
      accessor: 'purchase_number',

      Cell: ({ cell: { value }, row }) => {
        const popover = (
          <Popover>
            <Popover.Header className='fw-bolder text-hover-success fs-6'>
              <strong className='text-primary'>{value}</strong>
              <span className='h-10px border-gray-200 border-start mx-2'></span>
              Purchase Summary
            </Popover.Header>
            <Popover.Body>
              <div className='table-responsive'>
                <table className='table table-hover table-rounded table-striped border gy-3 gs-3'>
                  <thead>
                    <tr className='fw-bold fs-6 text-gray-800 border-bottom-2 border-gray-200'>
                      <th>Product</th>
                      <th>Quantity</th>
                    </tr>
                  </thead>
                  <tbody>
                    {row.original.items.map((x: any, key: number) => (
                      <tr key={key + x.product_id}>
                        <td className='text-dark text-nowrap fw-bolder fs-6' title={x.product_details?.product_name}>
                          {x.product_details?.product_name
                            ? truncate(x.product_details.product_name, 20)
                            : 'N/A'}
                        </td>
                        <td className='text-muted text-nowrap fw-bolder fs-6'>
                          {x.quantity}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </Popover.Body>
          </Popover>
        )

        return (
          <div className='d-flex align-items-center'>
            {onlyWidth > 576 && (
              <OverlayTrigger trigger={['hover', 'focus']} placement='right' overlay={popover}>
                <div className='symbol symbol-60px me-5'>
                  <span className='svg-icon svg-icon-primary svg-icon-3x'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      xmlnsXlink='http://www.w3.org/1999/xlink'
                      width='24'
                      height='24'
                      viewBox='0 0 24 24'
                    >
                      <g fill='none' fillRule='evenodd'>
                        <path d='M0 0L24 0 24 24 0 24z'></path>
                        <path
                          fill='#009ef7'
                          fillRule='nonzero'
                          d='M5.857 2h7.88a1.5 1.5 0 01.968.355l4.764 4.029A1.5 1.5 0 0120 7.529v12.554c0 1.79-.02 1.917-1.857 1.917H5.857C4.02 22 4 21.874 4 20.083V3.917C4 2.127 4.02 2 5.857 2z'
                          opacity='1'
                        ></path>
                        <rect width='9' height='2' x='6' y='11' fill='#fff' rx='1'></rect>
                        <rect width='5' height='2' x='6' y='15' fill='#fff' rx='1'></rect>
                      </g>
                    </svg>
                  </span>
                </div>
              </OverlayTrigger>)}
            <div className='d-flex justify-content-start flex-column'>
              <span className='text-dark fw-bolder fs-6' title={row.original.purchase_number}>
                {value}
                {onlyWidth <= 576 ? null : (<span className='h-10px border-gray-200 border-start mx-2'></span>)}
                <span className='text-success fw-bolder text-hover-success fs-6'>
                  {onlyWidth <= 576 ? null : Array(row.original.items)
                    .flatMap((f: any) => f)
                    .map((c: any) => c.quantity)
                    .reduce((a: number, b: number) => a + b, 0)}
                </span>
              </span>

              <span className='text-success fw-bolder d-block fs-7 text-truncate'>
                {row.original.supplier_details?.supplier_name || 'N/A'}

                <span className='text-muted fw-bold text-muted d-block fs-7 text-nowrap'>
                  {addCommas(row.original.total_amount)} {CURRENCY_APP}{' '}
                  <span className={`badge ${getPaymentStatusBadge(row.original.payment_status)} ms-1`}>
                    {row.original.payment_status}
                  </span>
                </span>
              </span>
            </div>
          </div>
        )
      },
    },

    {
      Header: 'Dates',
      accessor: 'purchase_date',
      Cell: ({ value, row }: any) => (
        <>
          <span className='text-primary fw-bolder fs-6 text-nowrap'>
            {dayjs(value).format('LL')}
          </span>
          <span className='text-muted fw-bold text-muted d-block fs-7 text-nowrap'>
            Due: {dayjs(row.original.due_date).format('LL')}
          </span>
        </>
      ),
    },
    { Header: 'id', accessor: 'purchase_id' },

    {
      Header: 'Status',
      accessor: 'status',
      Cell: ({ value, row }: any) => (
        <div className='d-flex flex-column align-items-start'>
          <span className={`badge ${getOrderStatusBadge(value)} mb-1`}>
            {value}
          </span>
          <span className={`badge ${getPaymentStatusBadge(row.original.payment_status)} badge-sm`}>
            Pay: {row.original.payment_status}
          </span>
        </div>
      ),
    },
    {
      Header: 'P.Amount',
      accessor: 'amount_paid',
      Cell: ({ value, row }: any) => (
        <>
          <span className='text-dark fw-bolder d-block mb-1 fs-6 text-nowrap' title={row.original.purchase_number}>
            {addCommas(Number(value))} {CURRENCY_APP}
          </span>
          <span className='text-muted fw-bold text-muted d-block fs-7 text-nowrap'>
            Due: {addCommas(row.original.balance_due)} {CURRENCY_APP}
          </span>
        </>
      ),
    },
  ], [])

  const actionColumn: Column<PurchaseData> = useMemo(() => ({
    Header: '',
    id: 'actions',
    Cell: ({ row }: any) => {
      const purchase = row.original;
      const isReceived = purchase.status === 'RECEIVED';
      const isReturned = purchase.status === 'RETURNED';
      const isPaid = purchase.payment_status === 'PAID';
      const isCompleted = isReceived && isPaid && !isReturned;

      return (
        <div className='d-flex justify-content-end flex-shrink-0'>
          {!isCompleted && (
            <>
              <a
                className='btn btn-icon btn-bg-light btn-active-color-success btn-sm me-1'
                onClick={() => handleAddItemsToPurchase(purchase)}
                title="Add Items to Purchase"
                style={{ cursor: 'pointer' }}
              >
                <span className='svg-icon svg-icon-3'>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="22"
                    height="22"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M12 6V18M6 12H18"
                      stroke="#009ef7"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
              </a>
              <a
                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                onClick={() => showpurchaseupdateModal(purchase)}
                title="Edit Purchase"
                style={{ cursor: 'pointer' }}
              >
                <span className='svg-icon svg-icon-3'>
                  <span className='svg-icon svg-icon-3'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='24'
                      height='24'
                      viewBox='0 0 24 24'
                      fill='none'
                    >
                      <path
                        opacity='0.3'
                        d='M21.4 8.35303L19.241 10.511L13.485 4.755L15.643 2.59595C16.0248 2.21423 16.5426 1.99988 17.0825 1.99988C17.6224 1.99988 18.1402 2.21423 18.522 2.59595L21.4 5.474C21.7817 5.85581 21.9962 6.37355 21.9962 6.91345C21.9962 7.45335 21.7817 7.97122 21.4 8.35303ZM3.68699 21.932L9.88699 19.865L4.13099 14.109L2.06399 20.309C1.98815 20.5354 1.97703 20.7787 2.03189 21.0111C2.08674 21.2436 2.2054 21.4561 2.37449 21.6248C2.54359 21.7934 2.75641 21.9115 2.989 21.9658C3.22158 22.0201 3.4647 22.0084 3.69099 21.932H3.68699Z'
                        fill='black'
                      ></path>
                      <path
                        d='M5.574 21.3L3.692 21.928C3.46591 22.0032 3.22334 22.0141 2.99144 21.9594C2.75954 21.9046 2.54744 21.7864 2.3789 21.6179C2.21036 21.4495 2.09202 21.2375 2.03711 21.0056C1.9822 20.7737 1.99289 20.5312 2.06799 20.3051L2.696 18.422L5.574 21.3ZM4.13499 14.105L9.891 19.861L19.245 10.507L13.489 4.75098L4.13499 14.105Z'
                        fill='black'
                      ></path>
                    </svg>
                  </span>
                </span>
              </a>

              <a
                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                onClick={() => showModaldelete(purchase)}
                title="Delete Purchase"
                style={{ cursor: 'pointer' }}
              >
                <span className='svg-icon svg-icon-3'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width={24}
                    height={24}
                    viewBox='0 0 24 24'
                    fill='none'
                  >
                    <path
                      d='M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z'
                      fill='#f1416c'
                    />
                    <path
                      opacity='0.5'
                      d='M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z'
                      fill='#f1416c'
                    />
                    <path
                      opacity='0.5'
                      d='M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z'
                      fill='#f1416c'
                    />
                  </svg>
                </span>
              </a>
            </>
          )}
          {isCompleted && (
            <span className='badge badge-light-success'>
              Completed
            </span>
          )}
        </div>
      )
    },
  }), [showpurchaseupdateModal, showModaldelete, handleAddItemsToPurchase])

  const expanderColumn: Column<PurchaseData> = useMemo(() => ({
    Header: () => null,
    id: 'expander',
    Cell: ({ row }: any) => (
      <span {...row.getToggleRowExpandedProps()} style={{ cursor: 'pointer' }}>
        {row.isExpanded ? (
          <span className='svg-icon svg-icon-primary'>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              xmlnsXlink='http://www.w3.org/1999/xlink'
              width='24'
              height='24'
              viewBox='0 0 24 24'
            >
              <g fill='none' fillRule='evenodd'>
                <path d='M0 0L24 0 24 24 0 24z'></path>
                <path
                  fill='#009ef7'
                  fillRule='nonzero'
                  d='M6.707 8.293a1 1 0 11-1.414 1.414l6 6a1 1 0 011.383.03l6-5.5a1 1 0 11-1.352-1.474l-5.294 4.853-5.323-5.323z'
                ></path>
              </g>
            </svg>
          </span>
        ) : (
          <span className='svg-icon svg-icon-primary'>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              xmlnsXlink='http://www.w3.org/1999/xlink'
              width='24'
              height='24'
              viewBox='0 0 24 24'
            >
              <g fill='none' fillRule='evenodd'>
                <path d='M0 0L24 0 24 24 0 24z'></path>
                <path
                  fill='#009ef7'
                  fillRule='nonzero'
                  d='M8.293 6.707a1 1 0 111.414-1.414l6 6a1 1 0 01.03 1.383l-5.5 6a1 1 0 11-1.474-1.352l4.853-5.294-5.323-5.323z'
                ></path>
              </g>
            </svg>
          </span>
        )}
      </span>
    ),
  }), [])

  // Updated purchase item columns to show the requested fields
  // Base purchase item columns
  const basePurchaseItemColumns: ReadonlyArray<Column<any>> = useMemo(() => [
    {
      Header: 'Product',
      accessor: 'product_details',
      id: 'product_name',
      Cell: ({ value }: any) => (
        <span className='text-primary fw-bolder fs-6 text-nowrap' title={value?.product_name || 'N/A'}>
          {truncate(value?.product_name || 'N/A', 20)}
        </span>
      ),
    },
    {
      Header: 'Quantity',
      accessor: 'quantity',
      Cell: ({ value, row }: any) => (
        <span className='text-dark fw-bolder fs-6 text-nowrap'>
          {value} {row.original.product_details?.unit_name || 'UNITS'}
        </span>
      ),
    },
    {
      Header: 'Category',
      accessor: 'product_details',
      id: 'category_name',
      Cell: ({ value }: any) => (
        <span className='text-info fw-bolder fs-6 text-nowrap'>
          {value?.category_name || 'UNCATEGORISED'}
        </span>
      ),
    },
    {
      Header: 'Unit Cost',
      accessor: 'unit_cost',
      Cell: ({ value }: any) => (
        <span className='text-dark fw-bolder fs-6 text-nowrap'>
          {addCommas(Number(value))} {CURRENCY_APP}
        </span>
      ),
    },
    {
      Header: 'T.Buying Price',
      accessor: 'total_cost',
      Cell: ({ value }: any) => (
        <span className='text-success fw-bolder fs-6 text-nowrap'>
          {addCommas(Number(value))} {CURRENCY_APP}
        </span>
      ),
    },
    {
      Header: '',
      id: 'actions',
      Cell: ({ row }: any) => {
        const item = row.original;
        const isReceived = item.purchase_status?.toLowerCase() === 'received';

        if (isReceived) return null;

        return (
          <div className='d-flex justify-content-end flex-shrink-0'>
            <a
              className='btn btn-icon btn-bg-light btn-active-color-danger btn-sm'
              onClick={() => showModaldeleteitem(item)}
              title="Delete Item"
              style={{ cursor: 'pointer' }}
            >
              <span className='svg-icon svg-icon-3'>
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width={24}
                  height={24}
                  viewBox='0 0 24 24'
                  fill='none'
                >
                  <path
                    d='M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z'
                    fill='#f1416c'
                  />
                  <path
                    opacity='0.5'
                    d='M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z'
                    fill='#f1416c'
                  />
                  <path
                    opacity='0.5'
                    d='M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z'
                    fill='#f1416c'
                  />
                </svg>
              </span>
            </a>
          </div>
        )
      },
    },
  ], [showModaldeleteitem])


  // Responsive purchase item columns
  const mobilePurchaseItemColumns = useMemo(() => [
    basePurchaseItemColumns[0], // Product
    basePurchaseItemColumns[1], // Quantity
    basePurchaseItemColumns[5], // Actions
  ], [basePurchaseItemColumns])

  const tabletPurchaseItemColumns = useMemo(() => [
    basePurchaseItemColumns[0], // Product
    basePurchaseItemColumns[1], // Quantity
    basePurchaseItemColumns[4], // T.Buying Price
    basePurchaseItemColumns[5], // Actions
  ], [basePurchaseItemColumns])

  const purchaseItemColumns = useMemo(() => {
    if (onlyWidth <= 576) return mobilePurchaseItemColumns
    if (onlyWidth <= 768) return tabletPurchaseItemColumns
    return basePurchaseItemColumns
  }, [onlyWidth, mobilePurchaseItemColumns, tabletPurchaseItemColumns, basePurchaseItemColumns])


  const mobileColumns = useMemo(() => [expanderColumn, baseColumns[0], actionColumn], [expanderColumn, baseColumns, actionColumn])
  const tabletColumns = useMemo(() => [baseColumns[0], baseColumns[2], baseColumns[3], actionColumn], [baseColumns, actionColumn])
  const desktopColumns = useMemo(() => [expanderColumn, ...baseColumns, actionColumn], [expanderColumn, baseColumns, actionColumn])

  const columndata = useMemo(() => {
    if (onlyWidth <= 576) return mobileColumns
    if (onlyWidth <= 768) return tabletColumns
    return desktopColumns
  }, [onlyWidth, mobileColumns, tabletColumns, desktopColumns])

  const filteredsubdata = (rowdata: any): number => rowdata.original.items?.length || 0
  const filteredtablesubData = (rowdata: any): any[] => rowdata.original.items.map((item: PurchaseItem) => ({
    ...item,
    purchase_status: rowdata.original.status
  })) || []

  return (
    <>
      <LoadingBar color='#009ef7' ref={refloadingbar} />
      <PageTitle breadcrumbs={usersBreadcrumbs}>Purchases</PageTitle>

      {/* Summary Cards */}
      {showDashboard && (
        <div className='row g-5 g-xl-8'>
          <div className='col-xl-4'>
            <ItemsSummary
              className='card-xl-stretch mb-xl-8'
              chartColor='primary'
              chartHeight='120px'
              cardName='T.Purchases'
              chartName='Total Amount'

              statusnow={statusnow}
              statusnow2={statusnow2}
              yaxisHeight={Math.abs(Math.max(...sumPurchasesdata.map((x: any) => x.total_purchases)))}
              chartCategories={sumPurchasesdata
                .sort((a: any, b: any) => (a.date_recordednow > b.date_recordednow ? 1 : -1))
                .map((x: any) => dayjs(x.date_recordednow).format('LL'))}
              chartData={sumPurchasesdata
                .sort((a: any, b: any) => (a.date_recordednow > b.date_recordednow ? 1 : -1))
                .map((x: any) => x.total_purchases)}

              values={
                <div className='fs-2 fw-bolder'>
                  <CountUp
                    className='text-primary'
                    end={sumPurchasesdata
                      .sort((a: any, b: any) => (a.date_recordednow > b.date_recordednow ? -1 : 1))
                      .map((x: any) => x.total_purchases)[0]}
                    duration={2}
                    decimals={2}
                    separator=','
                  />{' '}
                  <sup className='text-primary fs-6'>{CURRENCY_APP}</sup>
                </div>
              }
              values2={
                <>
                  <span className='fw-bold d-block fs-7 mt-2 text-muted'>
                    <table>
                      <tbody>
                        {(() => {
                          const sortedData = sumPurchasesdata.sort((a: any, b: any) => (a.date_recordednow > b.date_recordednow ? -1 : 1));
                          return (
                            <>
                              {sortedData[1] && (
                                <tr>
                                  <td>
                                    <span className='badge badge-light-primary'>
                                      {dayjs(sortedData[1].date_recordednow).calendar(null, {
                                        sameDay: '[Today]',
                                        nextDay: '[Tomorrow]',
                                        nextWeek: 'dddd',
                                        lastDay: '[Yesterday]',
                                        lastWeek: 'dddd',
                                        sameElse: 'DD/MM/YYYY',
                                      })}
                                    </span>
                                  </td>
                                  <td>
                                    <span className='h-20px border-gray-200 border-start mx-2'></span>
                                    <CountUp
                                      className='text-bold text-muted'
                                      end={sortedData[1].total_purchases}
                                      duration={2}
                                      decimals={2}
                                      separator=','
                                    />{' '}
                                    <sup className='text-muted'>{CURRENCY_APP}</sup>
                                  </td>
                                </tr>
                              )}

                              {sortedData[2] && (
                                <tr>
                                  <td>
                                    <span className='badge badge-light-primary'>
                                      {dayjs(sortedData[2].date_recordednow).calendar(null, {
                                        sameDay: '[Today]',
                                        nextDay: '[Tomorrow]',
                                        nextWeek: 'dddd',
                                        lastDay: '[Yesterday]',
                                        lastWeek: 'dddd',
                                        sameElse: 'DD/MM/YYYY',
                                      })}
                                    </span>
                                  </td>
                                  <td>
                                    <span className='h-20px border-gray-200 border-start mx-2'></span>
                                    <CountUp
                                      className='text-bold text-muted'
                                      end={sortedData[2].total_purchases}
                                      duration={2}
                                      decimals={2}
                                      separator=','
                                    />{' '}
                                    <sup className='text-muted'>{CURRENCY_APP}</sup>
                                  </td>
                                </tr>
                              )}
                            </>
                          );
                        })()}
                      </tbody>
                    </table>
                  </span>
                </>
              }
            />
          </div>
          {/* end::Col */}


          <div className='col-xl-4'>
            <ItemsSummary
              className='card-xl-stretch mb-xl-8'
              chartColor='success'
              chartHeight='120px'
              cardName='Total Paid'
              chartName='Paid'
              statusnow={statusnow}
              statusnow2={statusnow2}
              yaxisHeight={Math.abs(Math.max(...sumPurchasesdata.map((x: any) => x.total_paid)))}
              chartCategories={sumPurchasesdata
                .sort((a: any, b: any) => (a.date_recordednow > b.date_recordednow ? 1 : -1))
                .map((x: any) => dayjs(x.date_recordednow).format('LL'))}
              chartData={sumPurchasesdata
                .sort((a: any, b: any) => (a.date_recordednow > b.date_recordednow ? 1 : -1))
                .map((x: any) => x.total_paid)}
              values={
                <div className='fs-2 fw-bolder d-block'>
                  <CountUp
                    className='text-success'
                    end={sumPurchasesdata
                      .sort((a: any, b: any) => (a.date_recordednow > b.date_recordednow ? -1 : 1))
                      .map((x: any) => x.total_paid)[0]}
                    duration={2}
                    decimals={2}
                    separator=','
                  />{' '}
                  <sup>{CURRENCY_APP}</sup>
                </div>
              }
              values2={
                <>
                  <span className='fw-bold d-block fs-7 mt-2 text-muted'>
                    <table>
                      <tbody>
                        {(() => {
                          const sortedData = sumPurchasesdata.sort((a: any, b: any) => (a.date_recordednow > b.date_recordednow ? -1 : 1));
                          return (
                            <>
                              {sortedData[1] && (
                                <tr>
                                  <td>
                                    <span className='badge badge-light-success'>
                                      {dayjs(sortedData[1].date_recordednow).calendar(null, {
                                        sameDay: '[Today]',
                                        nextDay: '[Tomorrow]',
                                        nextWeek: 'dddd',
                                        lastDay: '[Yesterday]',
                                        lastWeek: 'dddd',
                                        sameElse: 'DD/MM/YYYY',
                                      })}
                                    </span>
                                  </td>
                                  <td>
                                    <span className='h-20px border-gray-200 border-start mx-2'></span>
                                    <CountUp
                                      className='text-bold text-muted'
                                      end={sortedData[1].total_paid}
                                      duration={2}
                                      decimals={2}
                                      separator=','
                                    />{' '}
                                    <sup className='text-muted'>{CURRENCY_APP}</sup>
                                  </td>
                                </tr>
                              )}

                              {sortedData[2] && (
                                <tr>
                                  <td>
                                    <span className='badge badge-light-success'>
                                      {dayjs(sortedData[2].date_recordednow).calendar(null, {
                                        sameDay: '[Today]',
                                        nextDay: '[Tomorrow]',
                                        nextWeek: 'dddd',
                                        lastDay: '[Yesterday]',
                                        lastWeek: 'dddd',
                                        sameElse: 'DD/MM/YYYY',
                                      })}
                                    </span>
                                  </td>
                                  <td>
                                    <span className='h-20px border-gray-200 border-start mx-2'></span>
                                    <CountUp
                                      className='text-bold text-muted'
                                      end={sortedData[2].total_paid}
                                      duration={2}
                                      decimals={2}
                                      separator=','
                                    />{' '}
                                    <sup className='text-muted'>{CURRENCY_APP}</sup>
                                  </td>
                                </tr>
                              )}
                            </>
                          );
                        })()}
                      </tbody>
                    </table>
                  </span>
                </>
              }
            />
          </div>

          <div className='col-xl-4'>
            <ItemsSummary
              className='card-xl-stretch mb-5 mb-xl-8'
              chartColor='danger'
              chartHeight='120px'
              cardName='Balance Due'
              chartName='Due'
              statusnow={statusnow}
              statusnow2={statusnow2}
              yaxisHeight={Math.abs(Math.max(...sumPurchasesdata.map((x: any) => x.total_purchases_due)))}
              chartCategories={sumPurchasesdata
                .sort((a: any, b: any) => (a.date_recordednow > b.date_recordednow ? 1 : -1))
                .map((x: any) => dayjs(x.date_recordednow).format('LL'))}
              chartData={sumPurchasesdata
                .sort((a: any, b: any) => (a.date_recordednow > b.date_recordednow ? 1 : -1))
                .map((x: any) => x.total_purchases_due)}
              values={
                <div className='fs-2 fw-bolder d-block'>
                  <CountUp
                    className='text-danger'
                    end={sumPurchasesdata
                      .sort((a: any, b: any) => (a.date_recordednow > b.date_recordednow ? -1 : 1))
                      .map((x: any) => x.total_purchases_due)[0]}
                    duration={2}
                    decimals={2}
                    separator=','
                  />{' '}
                  <sup className='text-danger fs-6'>{CURRENCY_APP}</sup>
                </div>
              }
              values2={
                <>
                  <span className='fw-bold d-block fs-7 mt-2 text-muted'>
                    <table>
                      <tbody>
                        {(() => {
                          const sortedData = sumPurchasesdata.sort((a: any, b: any) => (a.date_recordednow > b.date_recordednow ? -1 : 1));
                          return (
                            <>
                              {sortedData[1] && (
                                <tr>
                                  <td>
                                    <span className='badge badge-light-danger'>
                                      {dayjs(sortedData[1].date_recordednow).calendar(null, {
                                        sameDay: '[Today]',
                                        nextDay: '[Tomorrow]',
                                        nextWeek: 'dddd',
                                        lastDay: '[Yesterday]',
                                        lastWeek: 'dddd',
                                        sameElse: 'DD/MM/YYYY',
                                      })}
                                    </span>
                                  </td>
                                  <td>
                                    <span className='h-20px border-gray-200 border-start mx-2'></span>
                                    <CountUp
                                      className='text-bold text-muted'
                                      end={sortedData[1].total_purchases_due}
                                      duration={2}
                                      decimals={2}
                                      separator=','
                                    />{' '}
                                    <sup className='text-muted'>{CURRENCY_APP}</sup>
                                  </td>
                                </tr>
                              )}

                              {sortedData[2] && (
                                <tr>
                                  <td>
                                    <span className='badge badge-light-danger'>
                                      {dayjs(sortedData[2].date_recordednow).calendar(null, {
                                        sameDay: '[Today]',
                                        nextDay: '[Tomorrow]',
                                        nextWeek: 'dddd',
                                        lastDay: '[Yesterday]',
                                        lastWeek: 'dddd',
                                        sameElse: 'DD/MM/YYYY',
                                      })}
                                    </span>
                                  </td>
                                  <td>
                                    <span className='h-20px border-gray-200 border-start mx-2'></span>
                                    <CountUp
                                      className='text-bold text-muted'
                                      end={sortedData[2].total_purchases_due}
                                      duration={2}
                                      decimals={2}
                                      separator=','
                                    />{' '}
                                    <sup className='text-muted'>{CURRENCY_APP}</sup>
                                  </td>
                                </tr>
                              )}
                            </>
                          );
                        })()}
                      </tbody>
                    </table>
                  </span>
                </>
              }
            />
          </div>
        </div>)}
      {/* Main Table Card */}
      <KTCard>
        <KTCardBody className='py-4'>
          {/* Search Bar */}
          <div className='row mt-4'>
            <div className='col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start'>
              <div className='mb-2'>
                <h3 className='fw-bolder my-2'>All Purchases</h3>

              </div>
            </div>
            <div className='col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end'>
              <div className='mb-2'>
                <div className='d-flex align-items-center position-relative my-1'>
                  <button
                    className='btn btn-icon position-absolute top-50 end-0 translate-middle-y me-3'
                    onClick={handleSearch}
                    style={{ border: 'none', background: 'none' }}
                  >
                    <KTSVG
                      path='/media/icons/duotune/general/gen021.svg'
                      className='svg-icon-1 text-primary'
                    />
                  </button>
                  <input
                    type='text'
                    data-kt-user-table-filter='search'
                    className='form-control form-control-solid w-250px ps-4 pe-14'
                    placeholder='Search Purchases'
                    ref={myRefsearch}
                    onChange={handleSearchOnChange}
                    onKeyDown={handleSearchOnEnter}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Button Row */}
          <div className='row'>
            <div className='col-sm-12 col-md-12 d-flex align-items-center justify-content-center justify-content-md-start'>
              <div className='mb-2 me-auto'>
                {/* CSV Download Button - Far Left */}
                <a className='btn btn-info btn-sm mb-2 me-2' href='#' onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
                  e.preventDefault();
                  downloadReport();
                }}>
                  <KTSVG path='/media/icons/duotune/files/fil002.svg' className='svg-icon-1' />
                  {onlyWidth <= 576 ? '↓' : 'Download Report'}
                </a>
              </div>

              <div className='mb-2' style={{ display: "inline-grid", gridTemplateColumns: "1fr 1fr" }}>
                {/* Add Supplier Button */}
                <a className='btn btn-success btn-sm mb-2 me-2' href='#' onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
                  e.preventDefault();
                  showSupplierModal();
                }}
                  title={onlyWidth <= 576 ? 'Add Supplier' : ''}>
                  <KTSVG path='/media/icons/duotune/ecommerce/ecm006.svg' className='svg-icon-1' />
                  {onlyWidth <= 576 ? '+' : 'Add Supplier'}
                </a>

                {/* Add Purchase Button */}
                <a className='btn btn-primary btn-sm mb-2' href='#' onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
                  e.preventDefault();
                  showModal();
                }}
                  title={onlyWidth <= 576 ? 'Add Purchase' : ''}>
                  <KTSVG path='/media/icons/duotune/ecommerce/ecm002.svg' className='svg-icon-1' />
                  {onlyWidth <= 576 ? '+' : 'Add Purchase'}
                </a>
              </div>
            </div>
          </div>

          {/* Main Table */}
          <Maintable
            tabledata={tabledata}
            tabledata2={[]}
            columndata={columndata}
            columndata2={purchaseItemColumns}
            tablelength={tabledatalength}
            paginationsize={paginationsize}
            setPaginationsize={setPaginationsize}
            startlimit={startlimit}
            setstartlimit={setStartlimit}
            pageCount={pageCount}
            setPageCount={setPageCount}
            table1loaded={allpurchasesstatus === 'success'}
            table2loaded={true}
            hiddencolumnsmade={['notes', 'id']}
            setServersort={setServersort}
            movetofirstpage={movetofirstpage}
            setMovetofirstpage={setMovetofirstpage}
            tablename='Purchase Description'
            filteredsubdata={filteredsubdata}
            filteredtablesubData={filteredtablesubData}
          />
        </KTCardBody>
      </KTCard>

      {/* Modals - Conditionally rendered to prevent runtime errors */}
      {modalSupplierShow && <AddSupplier show={modalSupplierShow} handleClose={hideSupplierModal} />}
      {modalshow && <AddPurchase
        show={modalshow}
        handleClose={hideModal}
        ref={addPurchaseRef}
        mode={modalAddPurchaseMode}
        purchaseToUpdate={purchaseToAddTo}
        allpurchasesrefetch={allpurchasesrefetch}
        sumpurchaserefetch={sumpurchaserefetch}
        variancerefetch={variancerefetch}
      />}
      {modalpurchaseupdateshow && (
        <UpdatePurchase
          show={modalpurchaseupdateshow}
          purchasetoupdate={purchasetoupdate}
          handleClose={hideUpdateModal}
          allpurchasesrefetch={allpurchasesrefetch}
          sumpurchaserefetch={sumpurchaserefetch}
          variancerefetch={variancerefetch}
        />
      )}
      {modalshowdelete && (
        <DeletePurchase
          show={modalshowdelete}
          handleClose={hideModaldelete}
          deleteselectedpurchase={deleteselectedpurchase}
          purchasetodelete={purchasetodelete}
          statedeletingpurchase={statedeletingpurchase}
          cannotDeletepurchase={cannotDeletepurchase}
        />
      )}
      {modalshowdeleteitem && (
        <DeletePurchaseItem
          show={modalshowdeleteitem}
          handleClose={hideModaldeleteitem}
          itemtodelete={itemtodelete as PurchaseItem}
          allpurchasesrefetch={allpurchasesrefetch}
        />
      )}
    </>
  )
}

export default Purchases
